import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { AuthLayout } from '@/components/AuthLayout'
import { PasswordInput, Spinner } from '@/components/ui'
import { api } from '@/lib/api'

export function ResetPassword() {
  const [params] = useSearchParams()
  const token = params.get('token') || ''
  const navigate = useNavigate()

  const [next, setNext] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const valid = next.length >= 8 && /\d/.test(next) && next === confirm

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!valid) return
    setError(null)
    setBusy(true)
    try {
      await api.post('/auth/reset-confirm', { token, newPassword: next })
      navigate('/login', { replace: true })
    } catch (err) {
      setError((err as Error).message || 'El link es inválido o expiró.')
    } finally {
      setBusy(false)
    }
  }

  if (!token) {
    return (
      <AuthLayout title="Link inválido">
        <div className="card p-5 text-center text-sm text-ink-soft">
          El link de recuperación no es válido.
          <Link to="/login" className="mt-3 block font-semibold accent-text">
            Volver al login
          </Link>
        </div>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout title="Nueva contraseña">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="field-label">Nueva contraseña</label>
          <PasswordInput required value={next} onChange={(e) => setNext(e.target.value)} />
        </div>
        <div>
          <label className="field-label">Repetir contraseña</label>
          <PasswordInput required value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </div>
        <p className="text-xs text-ink-faint">Mínimo 8 caracteres y al menos 1 número.</p>
        {error && <div className="rounded-lg bg-danger/5 px-3 py-2 text-sm text-danger">{error}</div>}
        <button className="btn-primary btn-block" disabled={!valid || busy}>
          {busy ? <Spinner className="h-4 w-4" /> : 'Guardar contraseña'}
        </button>
      </form>
    </AuthLayout>
  )
}
